import { apiSlice } from './apiSlice';
import { AGENCY_TIER_WINDOWS_URL } from '../constants';

export const agencyTierWindowApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Auto-seeds the standard Tier2/3/4 rows (from the HSE table) on the
    // server the first time this is called, if they don't exist yet.
    getAgencyTierWindows: builder.query({
      query: () => AGENCY_TIER_WINDOWS_URL,
      providesTags: ['AgencyTierWindow'],
    }),

    // Create a brand-new tier's config (e.g. "Tier5").
    createAgencyTierWindow: builder.mutation({
      query: (data) => ({
        url: AGENCY_TIER_WINDOWS_URL,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['AgencyTierWindow'],
    }),

    // Replace an existing tier's label/bands.
    updateAgencyTierWindow: builder.mutation({
      query: ({ tier, ...data }) => ({
        url: `${AGENCY_TIER_WINDOWS_URL}/${tier}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['AgencyTierWindow'],
    }),

    deleteAgencyTierWindow: builder.mutation({
      query: (tier) => ({
        url: `${AGENCY_TIER_WINDOWS_URL}/${tier}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['AgencyTierWindow'],
    }),
  }),
});

export const {
  useGetAgencyTierWindowsQuery,
  useCreateAgencyTierWindowMutation,
  useUpdateAgencyTierWindowMutation,
  useDeleteAgencyTierWindowMutation,
} = agencyTierWindowApiSlice;
